import React, { Component } from 'react';
import './Home.css';
import Slideshow from '../Slideshow/Slideshow';
import Panel from '../Panel/Panel';

class Home extends Component {

    static contextTypes = {
        color: React.PropTypes.string,
        scroll: React.PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            mountedHeight: "100vH"
        };

        this.initialHeight = "100vH";
        this.currentWidth = 0;


    }

    changeHandler = (value, type) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, type);
        }
    }

    clickOnNews = () =>  {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(0, "page", "news");
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeBackground);
        this.resizeBackground();
    }

    resizeBackground = () => {

        if (this.currentWidth === 0 || this.currentWidth !== window.innerWidth) {
            this.currentWidth = window.innerWidth;
            //console.log(("resizeBackground - resizeBackground: " + window.innerHeight);


            if (window.innerHeight < 500) {
                this.setState({mountedHeight: Math.round(window.innerHeight*1.5) + "px"});
            } else {
                this.setState({mountedHeight: window.innerHeight + "px"});
            }

        }

    }


  render() {
    //var images = [{url: 'img/home/image01.jpg', name: 'home'}];
    var images = this.props.value.images;
    var buttons = [
        {type: 'overlay', title: 'Neuigkeiten und Angebote', to: '/aktuelles/0', onClick: this.clickOnNews},
        {type: 'anchor', title: 'Zu den Zimmern', to: '/zimmer'}
        ];
    return (
        <section id="home" className="Home" style={{'height': this.state.mountedHeight, 'maxHeight': this.state.mountedHeight, 'minHeight': this.state.mountedHeight}}>
            <div className="wrapper">
                <Slideshow className={"SlideShow"} images={images} />
            </div>
          <div className="Content">
              <div className="row PanelRow">
                  <div className="col-lg-12 col-md-12 col-xs-12">
                      <Panel headline={this.props.value.headline} cols={2} text_short={this.props.value.text_short}  text={this.props.value.text} buttons={buttons} onChange={null}/>
                  </div>
              </div>
          </div>
        </section>
    );
  }
}



export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js